export interface BookingTimeZoneOption {
  id: string
  label: string
  ianaTimeZones: string[]
}

export const BOOKING_TIME_ZONES: BookingTimeZoneOption[] = [
  // UTC-12
  {
    id: 'Dateline Standard Time',
    label: '(UTC-12:00) International Date Line West',
    ianaTimeZones: ['Etc/GMT+12'],
  },
  // UTC-11
  {
    id: 'UTC-11',
    label: '(UTC-11:00) Coordinated Universal Time-11',
    ianaTimeZones: ['Pacific/Niue', 'Pacific/Pago_Pago'],
  },
  // UTC-10
  {
    id: 'Hawaiian Standard Time',
    label: '(UTC-10:00) Hawaii',
    ianaTimeZones: ['Pacific/Honolulu'],
  },
  // UTC-9
  {
    id: 'Alaskan Standard Time',
    label: '(UTC-09:00) Alaska',
    ianaTimeZones: ['America/Anchorage', 'America/Juneau', 'America/Nome', 'America/Sitka', 'America/Yakutat'],
  },
  // UTC-8
  {
    id: 'Pacific Standard Time',
    label: '(UTC-08:00) Pacific Time (US & Canada)',
    ianaTimeZones: ['America/Los_Angeles', 'America/Vancouver'],
  },
  // UTC-7
  {
    id: 'US Mountain Standard Time',
    label: '(UTC-07:00) Arizona',
    ianaTimeZones: ['America/Phoenix', 'America/Creston'],
  },
  {
    id: 'Mountain Standard Time',
    label: '(UTC-07:00) Mountain Time (US & Canada)',
    ianaTimeZones: ['America/Denver', 'America/Edmonton', 'America/Boise', 'America/Cambridge_Bay'],
  },
  {
    id: 'Mountain Standard Time (Mexico)',
    label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
    ianaTimeZones: ['America/Chihuahua', 'America/Mazatlan'],
  },
  // UTC-6
  {
    id: 'Central Standard Time',
    label: '(UTC-06:00) Central Time (US & Canada)',
    ianaTimeZones: ['America/Chicago', 'America/Winnipeg', 'America/Indiana/Knox', 'America/Indiana/Tell_City'],
  },
  {
    id: 'Central Standard Time (Mexico)',
    label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    ianaTimeZones: ['America/Mexico_City', 'America/Monterrey', 'America/Matamoros'],
  },
  {
    id: 'Canada Central Standard Time',
    label: '(UTC-06:00) Saskatchewan',
    ianaTimeZones: ['America/Regina', 'America/Swift_Current'],
  },
  {
    id: 'Central America Standard Time',
    label: '(UTC-06:00) Central America',
    ianaTimeZones: ['America/Guatemala', 'America/Belize', 'America/Costa_Rica', 'America/El_Salvador', 'America/Managua', 'America/Tegucigalpa'],
  },
  // UTC-5
  {
    id: 'Eastern Standard Time',
    label: '(UTC-05:00) Eastern Time (US & Canada)',
    ianaTimeZones: ['America/New_York', 'America/Toronto', 'America/Detroit', 'America/Iqaluit'],
  },
  {
    id: 'Eastern Standard Time (Mexico)',
    label: '(UTC-05:00) Chetumal',
    ianaTimeZones: ['America/Cancun'],
  },
  {
    id: 'US Eastern Standard Time',
    label: '(UTC-05:00) Indiana (East)',
    ianaTimeZones: ['America/Indiana/Indianapolis', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac'],
  },
  {
    id: 'SA Pacific Standard Time',
    label: '(UTC-05:00) Bogota, Lima, Quito',
    ianaTimeZones: ['America/Bogota', 'America/Lima', 'America/Guayaquil'],
  },
  {
    id: 'Haiti Standard Time',
    label: '(UTC-05:00) Haiti',
    ianaTimeZones: ['America/Port-au-Prince'],
  },
  {
    id: 'Cuba Standard Time',
    label: '(UTC-05:00) Havana',
    ianaTimeZones: ['America/Havana'],
  },
  // UTC-4
  {
    id: 'Atlantic Standard Time',
    label: '(UTC-04:00) Atlantic Time (Canada)',
    ianaTimeZones: ['America/Halifax', 'America/Glace_Bay', 'America/Moncton', 'America/Thule', 'Atlantic/Bermuda'],
  },
  {
    id: 'Venezuela Standard Time',
    label: '(UTC-04:00) Caracas',
    ianaTimeZones: ['America/Caracas'],
  },
  {
    id: 'SA Western Standard Time',
    label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    ianaTimeZones: ['America/La_Paz', 'America/Manaus', 'America/Boa_Vista', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Guyana', 'America/Martinique', 'America/Barbados'],
  },
  {
    id: 'Paraguay Standard Time',
    label: '(UTC-04:00) Asuncion',
    ianaTimeZones: ['America/Asuncion'],
  },
  {
    id: 'Pacific SA Standard Time',
    label: '(UTC-04:00) Santiago',
    ianaTimeZones: ['America/Santiago'],
  },
  // UTC-3:30
  {
    id: 'Newfoundland Standard Time',
    label: '(UTC-03:30) Newfoundland',
    ianaTimeZones: ['America/St_Johns'],
  },
  // UTC-3
  {
    id: 'E. South America Standard Time',
    label: '(UTC-03:00) Brasilia',
    ianaTimeZones: ['America/Sao_Paulo'],
  },
  {
    id: 'Argentina Standard Time',
    label: '(UTC-03:00) City of Buenos Aires',
    ianaTimeZones: ['America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia'],
  },
  {
    id: 'SA Eastern Standard Time',
    label: '(UTC-03:00) Cayenne, Fortaleza',
    ianaTimeZones: ['America/Cayenne', 'America/Fortaleza', 'America/Belem', 'America/Maceio', 'America/Recife', 'America/Santarem', 'Antarctica/Rothera'],
  },
  {
    id: 'Greenland Standard Time',
    label: '(UTC-03:00) Greenland',
    ianaTimeZones: ['America/Godthab', 'America/Nuuk'],
  },
  {
    id: 'Montevideo Standard Time',
    label: '(UTC-03:00) Montevideo',
    ianaTimeZones: ['America/Montevideo'],
  },
  {
    id: 'Magallanes Standard Time',
    label: '(UTC-03:00) Punta Arenas',
    ianaTimeZones: ['America/Punta_Arenas'],
  },
  // UTC-2
  {
    id: 'UTC-02',
    label: '(UTC-02:00) Coordinated Universal Time-02',
    ianaTimeZones: ['America/Noronha', 'Etc/GMT+2'],
  },
  // UTC-1
  {
    id: 'Azores Standard Time',
    label: '(UTC-01:00) Azores',
    ianaTimeZones: ['Atlantic/Azores'],
  },
  {
    id: 'Cape Verde Standard Time',
    label: '(UTC-01:00) Cabo Verde Is.',
    ianaTimeZones: ['Atlantic/Cape_Verde'],
  },
  // UTC+0
  {
    id: 'UTC',
    label: '(UTC) Coordinated Universal Time',
    ianaTimeZones: ['UTC', 'Etc/UTC'],
  },
  {
    id: 'GMT Standard Time',
    label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
    ianaTimeZones: ['Europe/London', 'Europe/Dublin', 'Atlantic/Reykjavik'],
  },
  {
    id: 'Greenwich Standard Time',
    label: '(UTC+00:00) Monrovia, Reykjavik',
    ianaTimeZones: ['Africa/Abidjan', 'Africa/Accra', 'Africa/Monrovia', 'Africa/Nouakchott', 'Atlantic/St_Helena'],
  },
  // UTC+1
  {
    id: 'W. Europe Standard Time',
    label: '(UTC+01:00) Amsterdam, Berlin, Rome, Stockholm, Vienna',
    ianaTimeZones: ['Europe/Amsterdam', 'Europe/Berlin', 'Europe/Rome', 'Europe/Stockholm', 'Europe/Vienna', 'Europe/Luxembourg', 'Europe/Malta', 'Europe/Monaco', 'Europe/Zurich'],
  },
  {
    id: 'Central Europe Standard Time',
    label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    ianaTimeZones: ['Europe/Belgrade', 'Europe/Bratislava', 'Europe/Budapest', 'Europe/Ljubljana', 'Europe/Prague'],
  },
  {
    id: 'Romance Standard Time',
    label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    ianaTimeZones: ['Europe/Paris', 'Europe/Brussels', 'Europe/Copenhagen', 'Europe/Madrid'],
  },
  {
    id: 'Morocco Standard Time',
    label: '(UTC+01:00) Casablanca',
    ianaTimeZones: ['Africa/Casablanca', 'Africa/El_Aaiun'],
  },
  {
    id: 'W. Central Africa Standard Time',
    label: '(UTC+01:00) West Central Africa',
    ianaTimeZones: ['Africa/Lagos', 'Africa/Bangui', 'Africa/Brazzaville', 'Africa/Douala', 'Africa/Kinshasa', 'Africa/Libreville', 'Africa/Luanda', 'Africa/Malabo', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Porto-Novo', 'Africa/Tunis'],
  },
  // UTC+2
  {
    id: 'GTB Standard Time',
    label: '(UTC+02:00) Athens, Bucharest',
    ianaTimeZones: ['Europe/Athens', 'Europe/Bucharest', 'Asia/Nicosia', 'Asia/Famagusta'],
  },
  {
    id: 'Middle East Standard Time',
    label: '(UTC+02:00) Beirut',
    ianaTimeZones: ['Asia/Beirut'],
  },
  {
    id: 'Egypt Standard Time',
    label: '(UTC+02:00) Cairo',
    ianaTimeZones: ['Africa/Cairo'],
  },
  {
    id: 'E. Europe Standard Time',
    label: '(UTC+02:00) Chisinau',
    ianaTimeZones: ['Europe/Chisinau'],
  },
  {
    id: 'Syria Standard Time',
    label: '(UTC+02:00) Damascus',
    ianaTimeZones: ['Asia/Damascus'],
  },
  {
    id: 'West Bank Standard Time',
    label: '(UTC+02:00) Gaza, Hebron',
    ianaTimeZones: ['Asia/Gaza', 'Asia/Hebron'],
  },
  {
    id: 'South Africa Standard Time',
    label: '(UTC+02:00) Harare, Pretoria',
    ianaTimeZones: ['Africa/Johannesburg', 'Africa/Harare', 'Africa/Bujumbura', 'Africa/Gaborone', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Maputo', 'Africa/Maseru', 'Africa/Mbabane', 'Africa/Windhoek'],
  },
  {
    id: 'FLE Standard Time',
    label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    ianaTimeZones: ['Europe/Helsinki', 'Europe/Kiev', 'Europe/Kyiv', 'Europe/Riga', 'Europe/Sofia', 'Europe/Tallinn', 'Europe/Uzhgorod', 'Europe/Vilnius', 'Europe/Zaporozhye'],
  },
  {
    id: 'Israel Standard Time',
    label: '(UTC+02:00) Jerusalem',
    ianaTimeZones: ['Asia/Jerusalem'],
  },
  {
    id: 'Kaliningrad Standard Time',
    label: '(UTC+02:00) Kaliningrad',
    ianaTimeZones: ['Europe/Kaliningrad'],
  },
  {
    id: 'Sudan Standard Time',
    label: '(UTC+02:00) Khartoum',
    ianaTimeZones: ['Africa/Khartoum'],
  },
  {
    id: 'Libya Standard Time',
    label: '(UTC+02:00) Tripoli',
    ianaTimeZones: ['Africa/Tripoli'],
  },
  {
    id: 'Namibia Standard Time',
    label: '(UTC+02:00) Windhoek',
    ianaTimeZones: ['Africa/Windhoek'],
  },
  // UTC+3
  {
    id: 'Jordan Standard Time',
    label: '(UTC+03:00) Amman',
    ianaTimeZones: ['Asia/Amman'],
  },
  {
    id: 'Arabic Standard Time',
    label: '(UTC+03:00) Baghdad',
    ianaTimeZones: ['Asia/Baghdad'],
  },
  {
    id: 'Turkey Standard Time',
    label: '(UTC+03:00) Istanbul',
    ianaTimeZones: ['Europe/Istanbul'],
  },
  {
    id: 'Arab Standard Time',
    label: '(UTC+03:00) Kuwait, Riyadh',
    ianaTimeZones: ['Asia/Riyadh', 'Asia/Kuwait', 'Asia/Aden', 'Asia/Bahrain', 'Asia/Qatar'],
  },
  {
    id: 'Belarus Standard Time',
    label: '(UTC+03:00) Minsk',
    ianaTimeZones: ['Europe/Minsk'],
  },
  {
    id: 'Russian Standard Time',
    label: '(UTC+03:00) Moscow, St. Petersburg',
    ianaTimeZones: ['Europe/Moscow', 'Europe/Kirov', 'Europe/Simferopol', 'Europe/Volgograd'],
  },
  {
    id: 'E. Africa Standard Time',
    label: '(UTC+03:00) Nairobi',
    ianaTimeZones: ['Africa/Nairobi', 'Africa/Addis_Ababa', 'Africa/Asmara', 'Africa/Dar_es_Salaam', 'Africa/Djibouti', 'Africa/Kampala', 'Africa/Mogadishu', 'Indian/Antananarivo', 'Indian/Comoro', 'Indian/Mayotte'],
  },
  // UTC+3:30
  {
    id: 'Iran Standard Time',
    label: '(UTC+03:30) Tehran',
    ianaTimeZones: ['Asia/Tehran'],
  },
  // UTC+4
  {
    id: 'Arabian Standard Time',
    label: '(UTC+04:00) Abu Dhabi, Muscat',
    ianaTimeZones: ['Asia/Dubai', 'Asia/Muscat'],
  },
  {
    id: 'Astrakhan Standard Time',
    label: '(UTC+04:00) Astrakhan, Ulyanovsk',
    ianaTimeZones: ['Europe/Astrakhan', 'Europe/Ulyanovsk'],
  },
  {
    id: 'Azerbaijan Standard Time',
    label: '(UTC+04:00) Baku',
    ianaTimeZones: ['Asia/Baku'],
  },
  {
    id: 'Russia Time Zone 3',
    label: '(UTC+04:00) Izhevsk, Samara',
    ianaTimeZones: ['Europe/Samara', 'Europe/Ulyanovsk'],
  },
  {
    id: 'Mauritius Standard Time',
    label: '(UTC+04:00) Port Louis',
    ianaTimeZones: ['Indian/Mauritius', 'Indian/Mahe', 'Indian/Reunion'],
  },
  {
    id: 'Saratov Standard Time',
    label: '(UTC+04:00) Saratov',
    ianaTimeZones: ['Europe/Saratov'],
  },
  {
    id: 'Georgian Standard Time',
    label: '(UTC+04:00) Tbilisi',
    ianaTimeZones: ['Asia/Tbilisi'],
  },
  {
    id: 'Volgograd Standard Time',
    label: '(UTC+04:00) Volgograd',
    ianaTimeZones: ['Europe/Volgograd'],
  },
  {
    id: 'Caucasus Standard Time',
    label: '(UTC+04:00) Yerevan',
    ianaTimeZones: ['Asia/Yerevan'],
  },
  // UTC+4:30
  {
    id: 'Afghanistan Standard Time',
    label: '(UTC+04:30) Kabul',
    ianaTimeZones: ['Asia/Kabul'],
  },
  // UTC+5
  {
    id: 'West Asia Standard Time',
    label: '(UTC+05:00) Ashgabat, Tashkent',
    ianaTimeZones: ['Asia/Tashkent', 'Antarctica/Mawson', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Atyrau', 'Asia/Dushanbe', 'Asia/Oral', 'Asia/Samarkand', 'Indian/Kerguelen', 'Indian/Maldives'],
  },
  {
    id: 'Ekaterinburg Standard Time',
    label: '(UTC+05:00) Ekaterinburg',
    ianaTimeZones: ['Asia/Yekaterinburg'],
  },
  {
    id: 'Pakistan Standard Time',
    label: '(UTC+05:00) Islamabad, Karachi',
    ianaTimeZones: ['Asia/Karachi'],
  },
  {
    id: 'Qyzylorda Standard Time',
    label: '(UTC+05:00) Qyzylorda',
    ianaTimeZones: ['Asia/Qyzylorda'],
  },
  // UTC+5:30
  {
    id: 'India Standard Time',
    label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    ianaTimeZones: ['Asia/Kolkata', 'Asia/Calcutta'],
  },
  {
    id: 'Sri Lanka Standard Time',
    label: '(UTC+05:30) Sri Jayawardenepura',
    ianaTimeZones: ['Asia/Colombo'],
  },
  // UTC+5:45
  {
    id: 'Nepal Standard Time',
    label: '(UTC+05:45) Kathmandu',
    ianaTimeZones: ['Asia/Kathmandu', 'Asia/Katmandu'],
  },
  // UTC+6
  {
    id: 'Central Asia Standard Time',
    label: '(UTC+06:00) Astana',
    ianaTimeZones: ['Asia/Almaty', 'Antarctica/Vostok', 'Asia/Bishkek', 'Asia/Qostanay', 'Indian/Chagos'],
  },
  {
    id: 'Bangladesh Standard Time',
    label: '(UTC+06:00) Dhaka',
    ianaTimeZones: ['Asia/Dhaka', 'Asia/Thimphu'],
  },
  {
    id: 'Omsk Standard Time',
    label: '(UTC+06:00) Omsk',
    ianaTimeZones: ['Asia/Omsk'],
  },
  // UTC+6:30
  {
    id: 'Myanmar Standard Time',
    label: '(UTC+06:30) Yangon (Rangoon)',
    ianaTimeZones: ['Asia/Rangoon', 'Asia/Yangon', 'Indian/Cocos'],
  },
  // UTC+7
  {
    id: 'SE Asia Standard Time',
    label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    ianaTimeZones: ['Asia/Bangkok', 'Asia/Ho_Chi_Minh', 'Asia/Jakarta', 'Asia/Phnom_Penh', 'Asia/Pontianak', 'Asia/Saigon', 'Asia/Vientiane', 'Indian/Christmas'],
  },
  {
    id: 'Altai Standard Time',
    label: '(UTC+07:00) Barnaul, Gorno-Altaysk',
    ianaTimeZones: ['Asia/Barnaul'],
  },
  {
    id: 'W. Mongolia Standard Time',
    label: '(UTC+07:00) Hovd',
    ianaTimeZones: ['Asia/Hovd'],
  },
  {
    id: 'North Asia Standard Time',
    label: '(UTC+07:00) Krasnoyarsk',
    ianaTimeZones: ['Asia/Krasnoyarsk', 'Asia/Novokuznetsk'],
  },
  {
    id: 'N. Central Asia Standard Time',
    label: '(UTC+07:00) Novosibirsk',
    ianaTimeZones: ['Asia/Novosibirsk'],
  },
  {
    id: 'Tomsk Standard Time',
    label: '(UTC+07:00) Tomsk',
    ianaTimeZones: ['Asia/Tomsk'],
  },
  // UTC+8
  {
    id: 'China Standard Time',
    label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    ianaTimeZones: ['Asia/Shanghai', 'Asia/Hong_Kong', 'Asia/Macau'],
  },
  {
    id: 'North Asia East Standard Time',
    label: '(UTC+08:00) Irkutsk',
    ianaTimeZones: ['Asia/Irkutsk'],
  },
  {
    id: 'Singapore Standard Time',
    label: '(UTC+08:00) Kuala Lumpur, Singapore',
    ianaTimeZones: ['Asia/Singapore', 'Asia/Kuala_Lumpur', 'Asia/Brunei', 'Asia/Kuching', 'Asia/Makassar'],
  },
  {
    id: 'W. Australia Standard Time',
    label: '(UTC+08:00) Perth',
    ianaTimeZones: ['Australia/Perth'],
  },
  {
    id: 'Taipei Standard Time',
    label: '(UTC+08:00) Taipei',
    ianaTimeZones: ['Asia/Taipei'],
  },
  {
    id: 'Ulaanbaatar Standard Time',
    label: '(UTC+08:00) Ulaanbaatar',
    ianaTimeZones: ['Asia/Ulaanbaatar', 'Asia/Choibalsan'],
  },
  // UTC+8:45
  {
    id: 'Aus Central W. Standard Time',
    label: '(UTC+08:45) Eucla',
    ianaTimeZones: ['Australia/Eucla'],
  },
  // UTC+9
  {
    id: 'Transbaikal Standard Time',
    label: '(UTC+09:00) Chita',
    ianaTimeZones: ['Asia/Chita'],
  },
  {
    id: 'Tokyo Standard Time',
    label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    ianaTimeZones: ['Asia/Tokyo'],
  },
  {
    id: 'North Korea Standard Time',
    label: '(UTC+09:00) Pyongyang',
    ianaTimeZones: ['Asia/Pyongyang'],
  },
  {
    id: 'Korea Standard Time',
    label: '(UTC+09:00) Seoul',
    ianaTimeZones: ['Asia/Seoul'],
  },
  {
    id: 'Yakutsk Standard Time',
    label: '(UTC+09:00) Yakutsk',
    ianaTimeZones: ['Asia/Yakutsk', 'Asia/Khandyga'],
  },
  // UTC+9:30
  {
    id: 'Cen. Australia Standard Time',
    label: '(UTC+09:30) Adelaide',
    ianaTimeZones: ['Australia/Adelaide', 'Australia/Broken_Hill'],
  },
  {
    id: 'AUS Central Standard Time',
    label: '(UTC+09:30) Darwin',
    ianaTimeZones: ['Australia/Darwin'],
  },
  // UTC+10
  {
    id: 'E. Australia Standard Time',
    label: '(UTC+10:00) Brisbane',
    ianaTimeZones: ['Australia/Brisbane', 'Australia/Lindeman'],
  },
  {
    id: 'AUS Eastern Standard Time',
    label: '(UTC+10:00) Canberra, Melbourne, Sydney',
    ianaTimeZones: ['Australia/Sydney', 'Australia/Melbourne'],
  },
  {
    id: 'West Pacific Standard Time',
    label: '(UTC+10:00) Guam, Port Moresby',
    ianaTimeZones: ['Pacific/Port_Moresby', 'Antarctica/DumontDUrville', 'Pacific/Guam', 'Pacific/Saipan', 'Pacific/Truk'],
  },
  {
    id: 'Tasmania Standard Time',
    label: '(UTC+10:00) Hobart',
    ianaTimeZones: ['Australia/Hobart', 'Australia/Currie', 'Australia/Lord_Howe'],
  },
  {
    id: 'Vladivostok Standard Time',
    label: '(UTC+10:00) Vladivostok',
    ianaTimeZones: ['Asia/Vladivostok', 'Asia/Ust-Nera'],
  },
  // UTC+11
  {
    id: 'Lord Howe Standard Time',
    label: '(UTC+11:00) Lord Howe Island',
    ianaTimeZones: ['Australia/Lord_Howe'],
  },
  {
    id: 'Bougainville Standard Time',
    label: '(UTC+11:00) Bougainville Island',
    ianaTimeZones: ['Pacific/Bougainville'],
  },
  {
    id: 'Russia Time Zone 10',
    label: '(UTC+11:00) Chokurdakh',
    ianaTimeZones: ['Asia/Srednekolymsk'],
  },
  {
    id: 'Magadan Standard Time',
    label: '(UTC+11:00) Magadan',
    ianaTimeZones: ['Asia/Magadan'],
  },
  {
    id: 'Norfolk Standard Time',
    label: '(UTC+11:00) Norfolk Island',
    ianaTimeZones: ['Pacific/Norfolk'],
  },
  {
    id: 'Sakhalin Standard Time',
    label: '(UTC+11:00) Sakhalin',
    ianaTimeZones: ['Asia/Sakhalin'],
  },
  {
    id: 'Central Pacific Standard Time',
    label: '(UTC+11:00) Solomon Is., New Caledonia',
    ianaTimeZones: ['Pacific/Guadalcanal', 'Antarctica/Macquarie', 'Pacific/Efate', 'Pacific/Kosrae', 'Pacific/Noumea', 'Pacific/Pohnpei'],
  },
  // UTC+12
  {
    id: 'Russia Time Zone 11',
    label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
    ianaTimeZones: ['Asia/Kamchatka', 'Asia/Anadyr'],
  },
  {
    id: 'New Zealand Standard Time',
    label: '(UTC+12:00) Auckland, Wellington',
    ianaTimeZones: ['Pacific/Auckland'],
  },
  {
    id: 'UTC+12',
    label: '(UTC+12:00) Coordinated Universal Time+12',
    ianaTimeZones: ['Pacific/Tarawa', 'Pacific/Funafuti', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Nauru', 'Pacific/Wake', 'Pacific/Wallis'],
  },
  {
    id: 'Fiji Standard Time',
    label: '(UTC+12:00) Fiji',
    ianaTimeZones: ['Pacific/Fiji'],
  },
  {
    id: 'Chatham Islands Standard Time',
    label: '(UTC+12:45) Chatham Islands',
    ianaTimeZones: ['Pacific/Chatham'],
  },
  // UTC+13
  {
    id: 'UTC+13',
    label: '(UTC+13:00) Coordinated Universal Time+13',
    ianaTimeZones: ['Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Kiritimati'],
  },
  {
    id: 'Tonga Standard Time',
    label: "(UTC+13:00) Nuku'alofa",
    ianaTimeZones: ['Pacific/Tongatapu'],
  },
  {
    id: 'Samoa Standard Time',
    label: '(UTC+13:00) Samoa',
    ianaTimeZones: ['Pacific/Apia'],
  },
  {
    id: 'Line Islands Standard Time',
    label: '(UTC+14:00) Kiritimati Island',
    ianaTimeZones: ['Pacific/Kiritimati'],
  },
]

export function getInitialBookingTimeZone(defaultTimeZone: string): string {
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const matchedOption = BOOKING_TIME_ZONES.find((option) =>
    option.ianaTimeZones.includes(browserTimeZone),
  )

  if (matchedOption) {
    return matchedOption.id
  }

  return BOOKING_TIME_ZONES.some((option) => option.id === defaultTimeZone)
    ? defaultTimeZone
    : 'UTC'
}

export function getBookingTimeZoneLabel(timeZone: string): string {
  return BOOKING_TIME_ZONES.find((option) => option.id === timeZone)?.label ?? timeZone
}

export function windowsToIana(windowsTzId: string, fallback = 'UTC'): string {
  if (!windowsTzId) return fallback
  // Match by Windows ID (e.g. "Eastern Standard Time")
  const byId = BOOKING_TIME_ZONES.find((o) => o.id === windowsTzId)
  if (byId) return byId.ianaTimeZones[0]
  // Match by display label returned by Graph API (e.g. "(UTC-05:00) Eastern Time (US & Canada)")
  const byLabel = BOOKING_TIME_ZONES.find((o) => o.label === windowsTzId)
  if (byLabel) return byLabel.ianaTimeZones[0]
  // Already an IANA ID (e.g. "America/New_York") or plain "UTC"
  if (windowsTzId === 'UTC' || windowsTzId.includes('/')) return windowsTzId
  return fallback
}
